"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenObtainPair = instanceOfTokenObtainPair;
exports.TokenObtainPairFromJSON = TokenObtainPairFromJSON;
exports.TokenObtainPairFromJSONTyped = TokenObtainPairFromJSONTyped;
exports.TokenObtainPairToJSON = TokenObtainPairToJSON;
exports.TokenObtainPairToJSONTyped = TokenObtainPairToJSONTyped;
/**
 * Check if a given object implements the TokenObtainPair interface.
 */
function instanceOfTokenObtainPair(value) {
    if (!('refresh' in value) || value['refresh'] === undefined)
        return false;
    if (!('access' in value) || value['access'] === undefined)
        return false;
    return true;
}
function TokenObtainPairFromJSON(json) {
    return TokenObtainPairFromJSONTyped(json, false);
}
function TokenObtainPairFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'refresh': json['refresh'],
        'access': json['access'],
    };
}
function TokenObtainPairToJSON(json) {
    return TokenObtainPairToJSONTyped(json, false);
}
function TokenObtainPairToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {};
}
//# sourceMappingURL=tokenObtainPair.js.map